module.exports = __webpack_public_path__ + "img/meme_13.9a9bb2d3.jpg";